// extracted by mini-css-extract-plugin
export default {"header":"header_header__rnYEL","nav":"header_nav__j7rDS","breathingBlock":"header_breathingBlock__J9jO1","logo":"header_logo__JoflW","breathingLink":"header_breathingLink__fRpa1"};